import { ApiClient } from "../common/apiClient";
import { ApiResult } from "../common/apiResult";
import { getRequestOptions } from "../common/helpers";
import { JobStatus } from "../components/JobStatusPanel";

const API_BASE = `${process.env.REACT_APP_API_BASE_URL}/api/jobs`;

interface GetJobResponse {
  id: string;
  status: JobStatus;
  updatedAt: Date;
  outputUrl?: string;
  failReason?: string;
  outputFileName?: string;
}

interface PaginatedGetJobsResponse {
  jobs: GetJobResponse[];
  totalPages: number
}

interface GetJobsBulkResponse {
  jobs: GetJobResponse[];
}

export const JobService = {
  getJob: async (jobId: string): Promise<ApiResult<GetJobResponse>> => {
    const options = getRequestOptions();
    try {
      const result = await ApiClient.get<GetJobResponse>(`${API_BASE}/${jobId}`, options);
      return { data: result };
    } catch (err: any) {
      return {
        error: {
          message: err?.message || "Failed to get job status",
        },
      };
    }
  },
  getJobs: async (pageNumber: number): Promise<ApiResult<PaginatedGetJobsResponse>> => {
    const options = getRequestOptions();
    try {
      const result = await ApiClient.get<PaginatedGetJobsResponse>(`${API_BASE}?pageNumber=${pageNumber}`, options);
      return { data: result };
    } catch (err: any) {
      return {
        error: {
          message: err?.message || "Failed to get jobs",
        },
      };
    }
  },
  getJobsByIds: async (jobIds: string[]): Promise<ApiResult<GetJobsBulkResponse>> => {
    const options = getRequestOptions();
    try {
      const result = await ApiClient.post<GetJobsBulkResponse>(`${API_BASE}/bulk`, {
        jobIds
      }, options);
      return { data: result };
    } catch (err: any) {
      return {
        error: {
          message: err?.message || "Failed to get jobs",
        },
      };
    }
  },
};